import { render, staticRenderFns } from "./Review_key.vue?vue&type=template&id=73d813fb"
import script from "./Review_key.vue?vue&type=script&lang=js"
export * from "./Review_key.vue?vue&type=script&lang=js"
import style0 from "./Review_key.vue?vue&type=style&index=0&id=73d813fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports